import { render, staticRenderFns } from "./teacherDownLoad.vue?vue&type=template&id=6b03aaa3&"
import script from "./teacherDownLoad.vue?vue&type=script&lang=js&"
export * from "./teacherDownLoad.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports